export function AdminDetailPanel({ title, subtitle, children, emptyMessage = "Select a record to view details.", testId = "admin-detail-panel" }) {
  return (
    <div className="border-l border-zinc-200 bg-white min-h-[500px]" data-testid={testId}>
      <div className="p-6 border-b border-zinc-200">
        <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">Detail View</p>
        <h2 className="font-heading text-xl font-bold tracking-tight text-zinc-900 mt-2">{title || "No record selected"}</h2>
        {subtitle && <p className="text-sm text-zinc-500 mt-1">{subtitle}</p>}
      </div>
      <div className="p-6">
        {children || <div className="text-sm text-zinc-500" data-testid={`${testId}-empty`}>{emptyMessage}</div>}
      </div>
    </div>
  );
}